export const API_ENDPOINTS = {
  getPropertyData: '/offer_gfseext/getPropertyData',
  eligibilityCheck: '/offer_gfseext/cpr/validation'
};
